/**
 * @generated SignedSource<<5d19d844a0ad309b2347c2716dc2544e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceLineItemsInput = {
  id: string;
  lineItems: ReadonlyArray<InvoiceLineItemInput | null | undefined>;
};
export type InvoiceLineItemInput = {
  description: string;
  price?: number | null | undefined;
  quantity?: number | null | undefined;
  taxRatePercentage?: number | null | undefined;
  unitLabel?: string | null | undefined;
};
export type InvoiceLineItemsTableUpdateInvoiceLineItemsMutation$variables = {
  input: UpdateInvoiceLineItemsInput;
};
export type InvoiceLineItemsTableUpdateInvoiceLineItemsMutation$data = {
  readonly updateInvoiceLineItems: {
    readonly id: string;
    readonly lineItems: ReadonlyArray<{
      readonly description: string;
      readonly price: number | null | undefined;
      readonly quantity: number | null | undefined;
      readonly taxRatePercentage: number | null | undefined;
      readonly unitLabel: string | null | undefined;
    } | null | undefined>;
  };
};
export type InvoiceLineItemsTableUpdateInvoiceLineItemsMutation = {
  response: InvoiceLineItemsTableUpdateInvoiceLineItemsMutation$data;
  variables: InvoiceLineItemsTableUpdateInvoiceLineItemsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Invoice",
    "kind": "LinkedField",
    "name": "updateInvoiceLineItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceLineItem",
        "kind": "LinkedField",
        "name": "lineItems",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitLabel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxRatePercentage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvoiceLineItemsTableUpdateInvoiceLineItemsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvoiceLineItemsTableUpdateInvoiceLineItemsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e842b674d473812f937c665ffb0b6522",
    "id": null,
    "metadata": {},
    "name": "InvoiceLineItemsTableUpdateInvoiceLineItemsMutation",
    "operationKind": "mutation",
    "text": "mutation InvoiceLineItemsTableUpdateInvoiceLineItemsMutation(\n  $input: UpdateInvoiceLineItemsInput!\n) {\n  updateInvoiceLineItems(input: $input) {\n    id\n    lineItems {\n      quantity\n      unitLabel\n      description\n      price\n      taxRatePercentage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2d15a4627ba74fe2be46bf8a2520c2c";

export default node;
